import { render } from "./HomBlocosHomeView.vue?vue&type=template&id=e6bbe12e&scoped=true"
import script from "./HomBlocosHomeView.vue?vue&type=script&lang=js"
export * from "./HomBlocosHomeView.vue?vue&type=script&lang=js"

import "./HomBlocosHomeView.vue?vue&type=style&index=0&id=e6bbe12e&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6bbe12e"]])

export default __exports__